export default "__VITE_ASSET__CQi7c3Dy__"